import { Button, Typography } from '@mui/material';
import Box from '@mui/material/Box/Box';
import * as React from 'react';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Logo404 } from '../../components/Logo404';

const NotFound: FC = () => {
  return (
    <Box style={{ textAlign: 'center' }}>
      <Box sx={{ width: '100%' }}>
        <Logo404 width="100%" />
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
        Pearl not found! Oh, we mean page not found!
      </Typography>
      <Typography variant="h5" mt={1}>
        Sorry you got lost, but here is the way out...
      </Typography>

      <Button component={Link} to="/" aria-label="return to console" variant="contained" sx={{ mt: 4 }}>
        console landing page
      </Button>
    </Box>
  );
};

export default NotFound;
